<template>
	<section v-if="isLoadingOk" class="small text-hide-overflow">

		<!-- 1+ Favorites -->
		<div v-for="(favorite, idx) in favorites" :key="idx" class="bg-white b-rounded p-x-grid p-y-1 m-b-xs">
			<p class="m-b-0">
				<a :href="buildUrl(favorite)" class="font-weight-bold" :data-testid="`favoriteName_${favorite.name}`">{{ favorite.name }}</a>
			</p>
		</div>

		<p v-if="userKnown && favorites.length" class="m-x-grid m-y-sm">
			<a :href="savedSearchesNav" :data-testid="`manageFavoritesLink`">Manage Favorites</a>
		</p>

		<!-- No Favorites -->
		<div v-else-if="userKnown && !favorites.length" class="bg-white b-rounded p-x-grid p-y-1 m-b-xs">
			<span>No favorite class schedules</span>
			<span class="flex-card-cta">
				<a :href="classSchedulesNav">Add a Favorite</a>
			</span>
		</div>

		<!-- Not Logged In -->
		<div v-else-if="!userKnown" class="bg-white b-rounded p-x-grid p-y-1 m-b-xs">
			<a :href="loginNav">Log in to view favorite class schedules</a>
		</div>

	</section>
</template>

<script>
import { defineComponent } from 'vue';
import { baseComponentMixin } from '@/mixins/baseComponent.mixin';
import { FrameworkService } from '@/services/framework.service';
import _ from 'lodash';

export default defineComponent({
	name: 'SavedSearchesBriefComponent',
	config: {
		key: 'schreg.savedSearchesBrief',
		devPath: 'saved-searches-brief',
		exported: true
	},
	mixins: [baseComponentMixin],
	data() {
		return {
			favorites: [],
			savedSearchesNav: '',
			classSchedulesNav:'',
			loginNav: ''
		};
	},
	mounted() {
		this.getFrameworkData(this.completeMounting, ['ClubStore', 'ProfileStore', 'UrlStore']);
	},
	methods: {
		completeMounting() {
			const classesUrl = FrameworkService.clubUrl('classes');
			this.savedSearchesNav = `${classesUrl}?showFavorites=true`;
			this.classSchedulesNav = `${classesUrl}?showFilters=true`;
			this.loadFavorites();
			this.isLoadingOk = true;
		},

		loadFavorites() {
			if (this.userKnown) {
				const personalization = FrameworkService.data('profile.personalization');
				const schregSavedSearches = _.orderBy(personalization.schregSavedSearches, function(a) {
					return new Date(a.lastUsed);
				}, ['desc']);

				this.favorites = personalization ? schregSavedSearches.slice(0,3) : [];
			}
		},

		buildUrl(search) {
			return FrameworkService.classSearchFavoriteUrl(search.name);
		}
	}
});
</script>

<style lang="scss">
@import "@/common/styles/flex-card.scss";
</style>
